"use client";
import { Button, ButtonProps } from "@chakra-ui/react";
import { getDashboardUrl } from "@ui/../config/src";
import { usePremiumRoutes } from "@ui/utils";
import { signIn } from "next-auth/react";
import { usePathname } from "next/navigation";
export const AuthButton = (props: ButtonProps) => {
  const pathname = usePathname();
  const sessionOpts =
    process.env.APP_NAME !== "PREMIUM"
      ? {
          required: false,
          onUnauthenticated: () => {},
        }
      : undefined;
  const { status, router, redirectUrl } = usePremiumRoutes(sessionOpts);

  if (
    pathname !== "/" &&
    status === "authenticated" &&
    process.env.APP_NAME === "PREMIUM"
  ) {
    return (
      <Button {...props} onClick={() => router.push(redirectUrl)}>
        Dashboard
      </Button>
    );
  }
  return (
    <Button
      {...props}
      onClick={() =>
        pathname === "/"
          ? window.open("https://enterprise.areahub.com/api/auth/login")
          : process.env.APP_NAME === "PREMIUM"
          ? signIn("auth0", {
              callbackUrl: "/api/route-user",
            })
          : window.open(getDashboardUrl() + "/login")
      }
      isLoading={status === "loading"}
      loadingText="Loading"
    >
      {props.children}
    </Button>
  );
};

export const SignInButton = (props: ButtonProps) => {
  const pathname = usePathname();
  return (
    <Button
      {...props}
      onClick={() => {
        pathname === "/"
          ? window.open("https://enterprise.areahub.com/api/auth/login")
          : window.open(getDashboardUrl());
      }}
    >
      {props.children}
    </Button>
  );
};
